<script setup lang="ts">
import { computed, ref } from "vue";

const sampleMode = ref<"with" | "without">("with");

const activeSample = computed(() => {
  if (sampleMode.value === "with") {
    return {
      code: "# naam display karna hai\nprint('Ali')",
      runs: ["print('Ali')"],
      output: "Ali",
    };
  }

  return {
    code: "print('Ali')",
    runs: ["print('Ali')"],
    output: "Ali",
  };
});
</script>

<template>
  <section class="space-y-4 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div>
      <h2 class="text-lg font-semibold text-slate-900">Yahan dekh kar samjho</h2>
      <p class="mt-1 text-sm text-slate-600">Comment ho ya na ho, Python sirf asli code chalata hai.</p>
    </div>

    <div class="flex gap-2">
      <button
        type="button"
        class="rounded-full px-3 py-1.5 text-xs font-medium transition"
        :class="sampleMode === 'with' ? 'bg-slate-950 text-white' : 'bg-slate-100 text-slate-700'"
        @click="sampleMode = 'with'"
      >
        Code with comment
      </button>
      <button
        type="button"
        class="rounded-full px-3 py-1.5 text-xs font-medium transition"
        :class="sampleMode === 'without' ? 'bg-slate-950 text-white' : 'bg-slate-100 text-slate-700'"
        @click="sampleMode = 'without'"
      >
        Code without comment
      </button>
    </div>

    <div class="grid gap-3">
      <article class="rounded-2xl bg-slate-950 p-4 text-slate-100">
        <p class="text-xs font-semibold uppercase tracking-wide text-sky-200">Code</p>
        <pre class="mt-3 overflow-x-auto text-xs leading-6"><code>{{ activeSample.code }}</code></pre>
      </article>

      <article class="rounded-2xl bg-emerald-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-emerald-700">Yeh lines chalti hain</p>
        <ul class="mt-3 space-y-2 text-sm text-emerald-900">
          <li v-for="line in activeSample.runs" :key="line">{{ line }}</li>
        </ul>
      </article>

      <article class="rounded-2xl bg-sky-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-sky-700">Output</p>
        <p class="mt-3 text-sm font-semibold text-sky-900">{{ activeSample.output }}</p>
      </article>
    </div>
  </section>
</template>
